import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '@aiwyn/config';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss'],
  standalone: false,
})
export class EmptyPageComponent implements OnInit {

  @Input() title: string
  @Input() text: string

  // PV5
  @Output() onPayWithoutInvoice = new EventEmitter<void>();

  constructor(
    private configService: ConfigService,
  ) {}

  ngOnInit(): void {
    if (this.text.includes("companyName")) {
      this.text = this.text.replace(/companyName/g, this.configService.customerName);
    }
  }
}
